import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { SetsKey } from './keys';

export const locales = {
  en,
  nl: nl as Record<SetsKey, string>,
  ro: ro as Record<SetsKey, string>,
} as const satisfies Partial<Record<LangCode, Record<SetsKey, string>>> & {
  en: Record<SetsKey, string>;
};
export type { SetsKey } from './keys';
